// export const BASEURL2="http://127.0.0.1:8203/api/v1";
// export const BASEURL="http://101.231.81.202:8400/appportal";//上海
// export const BASEURL_AUTH="http://127.0.0.1:8221/api/v1";

// export const BASEURL_YJ = "http://192.168.0.51:8203";//V1.2 邮件微服务地址
declare var BASEURL2;
declare var BASEURL;
declare var BASEURL_AUTH;
declare var BASEURL_YKF;
declare var BASEURL_TS;
declare var BASEURL_KB;
declare var BASE_DOWNLOAD_APK_URL;

declare var CAS_LOGOUT;

export const LOGOUT_CAS = CAS_LOGOUT;
export const LOGIN = BASEURL_AUTH+"/auth/login";//登陆url对应值
export const LOGINWX = BASEURL_AUTH+"/auth/loginWx";//微信登录URL
export const LOGOUTWX = BASEURL_AUTH+"/auth/logoutWx2";//微信退出URL
export const SYSTEM_URL = BASEURL2 + "/appportalwap";//移动门户访问URL
export const THIRD_APP_JUMP = BASEURL_AUTH + "/auth/thridApp/jump";//

export const RNEWS = "rnewUrl";//获取轮播新闻信息

export const PNEWS = BASEURL+"/home/nnews/list.action";//获取首页通知新闻

export const DEFAULTAPPLY = "defaultApplyUrl";//获取默认应用

export const ACTIVEACCOUNT = "activeAccountUrl";//账号激活地址

export const BINDPHONE = "bindPhoneUrl";//绑定手机号，获取验证码
export const VERIFYCODE = "verifyCodeUrl";//验证验证码

export const MODIFYPWD = "modifyPwdUrl";//修改密码

export const APPLYLIST = "applyListUrl";//服务列表

export const APPLYDELE = "applyDeleUrl";//服务删除

export const APPLYADD = "applyAddUrl";//服务添加

export const NEWSLIST = BASEURL+"/home/nnews/listPage.action";//新闻列表

export const NEWSDETAIL = "newsDetailUrl";//新闻详情

export const SEARCH = "searchUrl";//全局搜索

export const PHVERIFYCODE = "phverifyCodeUrl";//获取手机验证码

export const PHVERIFY = "phVerifyUrl";//手机验证

export const MSGCOUNT = BASEURL+"/home/nMsg/msgCount.action";//消息数量

export const MSGLIST = BASEURL+"/home/nMsg/msgList.action";//消息列表

export const MSGDETAIL = "msgDetailUrl";//消息详情

export const RECEIPT = "receiptUrl";//提交回执

export const APPLYSEARCH = "applySearchUrl";//应用搜索

export const TRIPSAVEORUPDATE = "tripSaveOrUpdateUrl";//日程新增更新

export const SAVEORUPDATE =  "saveOrUpdateUrl";//新增更新

export const QUERYCALENDAR = "queryCalendarUrl";//查询日历

export const DELETETRIP = "deleteTripUrl"; //删除日历行程

export const MONTHTRIPLIST = "monthTripListUrl";//查询月行程

export const WEEKTRIPLIST = "weekTripListUrl";//查询周行程


export const PERSONINFO = BASEURL + "/home/Teaching/getPersonalInfo.action";//个人信息

export const SCORELIST = BASEURL + "/home/Teaching/getScoreList.action";//成绩查询

export const ELECTIVERESULT = BASEURL + "/home/Teaching/getElectiveList.action";//选课结果

export const SSEMESTERLIST =  BASEURL + "/home/Teaching/getCJSemesters.action";//成绩查询需要的学年学期

export const ESEMESTERLIST =  BASEURL + "/home/Teaching/getXKSemesters.action";//选课查询需要的学年学期

export const GETWEEKBYDATE = BASEURL + "/home/Teaching/getWeekly.action";//根据日期获得教学周日期

export const GETLESSONS = BASEURL + "/home/Teaching/getLessons.action";//获取节次

export const SALARYINFO = BASEURL + "/home/salary/getSalaryByUserId.action";//获取工资详情

export const YEARLIST = BASEURL+"/home/Research/queryYear.action";//年份查询

export const COPYRIGHTLIST = BASEURL+"/home/Research/queryCopyright.action";//著作权成果

export const IDENTIFICATIONLIST = BASEURL+"/home/Research/queryIdentification.action";//鉴定成果

export const PATENTYEARLIST = BASEURL+"/home/Research/queryPatentYear.action";//鉴定成果年份查询

export const PATENTLIST = BASEURL+"/home/Research/queryPatent.action";//鉴定成果

export const PRIZEYEARLIST = BASEURL+"/home/Research/queryPrizeYear.action";//获奖成果年份查询

export const PRIZELIST = BASEURL+"/home/Research/queryPrize.action";//获奖成果

export const PRODUCTIONYEARLIST = BASEURL+"/home/Research/queryProductionYear.action";//著作成果年份查询

export const PRODUCTIONLIST = BASEURL+"/home/Research/queryProduction.action";//著作成果

export const THESISYEARLIST = BASEURL+"/home/Research/queryThesisYear.action";//论文成果年份查询

export const THESISLIST = BASEURL+"/home/Research/queryThesis.action";//论文成果

export const PROJECTLIST = BASEURL+"/home/Research/queryProject.action";//项目成果

export const APPOINTTLIST = BASEURL+"/home/Appoint/queryAppoint.action";//专业技术职务聘任

export const BOOKUSERINFO = BASEURL+"/home/library/queryList.action";//查询欠款和当前借阅册数 及详细

export const DUEDATELIST = BASEURL+"/home/library/dueDateList.action";//获取过期册数  及详细

export const HISTORYLIST = BASEURL+"/home/library/historyList.action";//查询获取借阅历史图书数 及 详细借阅历史

export const HISCARDLIST = BASEURL+"/home/ykt/yktList.action";//查询一卡通消费记录

export const CARDFEE = BASEURL+"/home/ykt/fee.action";//查询一卡通消费记录

export const UNIFIEDADDRESSBOOKLIST = BASEURL+"/home/address/queryAddress.action";//统一通讯录

export const YZSQ = BASEURL+"/home/location/yzsq.action";//印章申请
export const FRZSQ = BASEURL+"/home/location/frzsq.action";//法人证申请
export const XZSQSQ = BASEURL+"/home/location/xzsqsq.action";//校长审签申请
export const SSKTSQ = BASEURL+"/home/location/sskt.action";//
export const JSQKDRWSQ = BASEURL+"/home/location/kdrw.action";//
export const DB = BASEURL+"/home/location/db.action";//流程待办
export const BJ = BASEURL+"/home/location/bj.action";//流程办结
export const JXZ = BASEURL+"/home/location/jxz.action";//流程进行中

//首页相关的请求链接
export const HOME_LIST= BASEURL2+"/api/v1/portal/card/info";//卡片栏目
export const HOME_SLIDES = BASEURL2+"/api/v1/portal/cms/getSlides";//幻灯片
export const HOME_NEWS = BASEURL2+"/api/v1/portal/cms/getNewsList";//新闻资讯
export const HOME_REC_APPS = BASEURL2+"/api/v1/portal/service/getRecommand";//推荐服务
export const HOME_COLL_APPS = BASEURL2+"/api/v1/portal/service/getMyCollect";//我的服务

export const HOME_YKT_YE = BASEURL_YKF+"/yktxf/getYktRemainMoneyByXgh";//根据学工号获取一卡通余额


//新闻相关的请求链接
export const NEWS_TYPES = BASEURL2+"/api/v1/portal/cms/getNewsTypes";//新闻分类（新闻中心下的子栏目）
export const NEWS_BY_TYPE = BASEURL2+"/api/v1/portal/cms/getNewsList";//按分类获取新闻列表
export const NEWS_DETAIL = BASEURL2+"/api/v1/portal/cms/getNewsDetail";//新闻详情
export const NEWS_SEARCH_BY_KEYWORD = BASEURL2+"/api/v1/portal/cms/getNewsSearch";//新闻搜索

//服务相关请求链接
export const SERVICE_SELECT_MYCOLLECT = BASEURL2 + "/api/v1/portal/service/getMyCollect";//我的服务
export const SERVICE_SELECT_MYALL_APPTYPES = BASEURL2 + "/api/v1/portal/service/getServiceByType";//服务列表分类获取
export const SERVICE_SAVE_COLLECTAPP = BASEURL2+"/api/v1/portal/service/saveCollect";//批量保存收藏服务
export const SEARCH_SELECT_MYAPPS = BASEURL+"/home/service/searchSelectMyApps.action";//查询我的所有应用
export const SEARCH_MYALLAPPS_BY_KEYWORD = BASEURL2+"/api/v1/portal/service/getAll";//我的所有应用中搜索应用

//消息请求相关链接
export const SELECT_MSG_CATEGORY = BASEURL2 + "/api/v1/portal/message/getMessageCategory";//消息分类（分类方式，01 提醒，02 待办）（带未读数）
export const SELECT_MSG_LIST_BY_CATEGORYID = BASEURL+"/home/message/selectMsgListByCategoryId.action";//按分类获取消息列表
export const MARK_MSG_BY_CATEGORYID = BASEURL2+"/api/v1/portal/message/getMessageReaded";//提醒消息标记已读
export const SEARCH_MYREMINDER = BASEURL2+"/api/v1/portal/message/messageSearch";//提醒搜索
export const SEARCH_MYTODO = BASEURL2+"/api/v1/portal/message/messageSearch";//待办搜索
export const SELECT_SUBTYPES_URL = BASEURL2 + "/api/v1/portal/message/getMessageEvent";//获取分类事项列表
export const SELECT_MSGLIST_URL = BASEURL2 + "/api/v1/portal/message/getMessages";//根据分类事项获取消息列表


//我请求相关链接
export const LOAD_SECURITY_INFO = BASEURL2+"/api/v1/uniauth/security/loadSecurityInfo";//加载安全信息
export const SAVE_UPDATE_PWD = BASEURL2+"/api/v1/uniauth/security/updatePwd";//修改密码
export const GENERATE_CODE_MOBILE = BASEURL2+"/api/v1/uniauth/security/generaterCodeMobile";//绑定手机 - 发送验证码
export const SAVE_CODE_MOBILE = BASEURL2+"/api/v1/uniauth/security/saveCodeMobile";//绑定手机 - 保存手机

//apk版本升级相关
export const CHECKLATESTVERSION = BASEURL2 + "/api/v1/portal/apk/checkLatestVersion";//检测升级
export const APK_DOWNLOAD = BASE_DOWNLOAD_APK_URL +"/appportal/apk" ;//apk在服务器的路径
export const IOS_APPSTORE_URL = "https://itunes.apple.com/us/app/树维智慧校园/id1432456076?l=zh&ls=1&mt=8";

//内置服务编号
/**一卡通内置服务编号 */
export const SERVICE_YKT_CODE='06';
export const SERVICE_YKT_URL=BASEURL2+"/service/#/common/yktxf?mobileServiceCode=06&innerUser=";
/**图书借阅内置服务编号 */
export const SERVICE_TSJY_CODE='03';
export const SERVICE_TSJY_URL=BASEURL2+"/service/#/common/tsjycx?mobileServiceCode=03&innerUser=";
/**课表查询内置服务编号 */
export const SERVICE_KBCX_CODE='05';
export const SERVICE_KBCX_URL=BASEURL2+"/service/#/common/schedule?mobileServiceCode=05&innerUser=";
/**图书借阅查询 */
export const TSJYCX_BORROWNUM_URL =  BASEURL_TS+"/book/borrow";

/**课表重要通知 */
export const KBCX_IMPORTANCE_NOTICE_URL =  BASEURL_KB+"/schedule/getImportNotice";

/**未读邮件数量接口 */
export const UNREAD_MAIL_MOUNT_URL = BASEURL2 + "/api/v1/portal/mail/unread";

/**邮件单点登录 */
export const MAIL_URL = BASEURL2 + "/api/v1/portal/mail/url";

// 邮箱绑定功能
/**用户账号是否已绑定邮箱 */
export const CHECK_BIND_MAIL = BASEURL2 + "/api/v1/portal/mail/checkIsBindMail";
/**发送邮箱验证码 */
export const SEND_EMAIL_CODE = BASEURL2 + "/api/v1/portal/mail/sendEmailCode";
/**绑定邮箱 */
export const SAVE_BIND_MAIL = BASEURL2 + "/api/v1/portal/mail/saveBindMail";

// 修改密码
/**判断是否是弱密码登录 */
export const CHECK_IS_WEAK_PWD = BASEURL2 + "/api/v1/uniauth/security/checkPWIsUsable";
export const SAVE_UPDATE_PWD2 = BASEURL2 + "/api/v1/uniauth/security/saveUpdatePwd";

/**获取密码策略 */
export const PWD_COM_POLICY = BASEURL2 + "/api/v1/uniauth/security/getPassCombPolicy";


// WEBPACK FOOTER //
// ./src/providers/config/serviceurl.ts